'use strict';

angular.module('TurneroApp').service('centrosAtencionService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/CentroAtencion/:id', { id: '@Id_CentroAtencion' }, {
        getCombo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/combo/',
            headers: portal.getHeadersServer(),
            isArray: true
        },
        getData: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/GetData',
            headers: portal.getHeadersServer()

        },
        getfiltro: {
            method: 'GET',
            withcredentials: true,
            headers: portal.getHeadersServer(),

        },
        save: {
            method: 'POST',
            headers: portal.getHeadersServer()
        },
        'delete': {
            method: 'DELETE',
            //headers: portal.getHeadersServer()
        },
        update: {
            method: 'PUT',
            params:{
               id: '@id'
            },
            url: portal.getUrlServer() + 'api/CentroAtencion/actualizarCentro/',
        },
        cambiarClave: {
            method: 'PUT',
            params: { id: '@id', nuevaPassword: '@nuevaPassword' },
            url: portal.getUrlServer() + 'api/CentroAtencion/cambiarPassword/',
            headers: portal.getHeadersServer()
        },
        Get_X_Tramite: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/PorTramite/',
        },
        Get_Recepcion_Modalidad: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/Get_Recepcion_Modalidad',
        },
        Get_Centro_Atencion_Combo: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/comboLogin/',
            isArray: true
        },
        Login_Centro: {
            method: 'GET',
            params: {
                id_centro_atencion: '@id_centro_atencion',
                clave_autogestion: '@clave_autogestion'
            },
            url: portal.getUrlServer() + 'api/CentroAtencion/login/'
        },
        Get_Centro_x_Tramite_Combo: {
            method: 'GET',
            //params: {
            //    id_centro_atencion: '@id_centro_atencion',
            //    clave_autogestion: '@clave_autogestion'
            //},
            url: portal.getUrlServer() + 'api/CentroAtencion/Get_Centro_x_Tramite_Combo/'
        },
        Get_Centros_Atencion_Telef_Combo: {
        	method: 'GET',
        	url: portal.getUrlServer() + 'api/CentroAtencion/Get_Centros_Atencion_Telef_Combo/'
        },

        Get_Combo_Centros_Atencion: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/Get_Combo_Centros_Atencion/',
            cancellable: true
        },

        Get_Combo_Centros_Atencion_x_Usuario: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/Get_Combo_Centros_Atencion_x_Usuario/',
            cancellable: true
        },
        updateSede: {
            method: 'PUT',
            url: portal.getUrlServer() + 'api/CentroAtencion/sede/:id',
        },

        saveSede:{
            method: 'POST',
            params:{
                cuit: '@cuit'
             },
            url: portal.getUrlServer() + 'api/CentroAtencion/sede/',
        },
        getZonas: {
            method: 'GET',
            url: portal.getUrlServer() + 'api/CentroAtencion/zonas'
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/centrosAtencion/centrosAtencionService.js